<template>
  <div class="c-contact-form">
    <div class="c-contact-form__state" v-show="state === 'form'">
      <header>
        <h2>お問い合わせ</h2>
      </header>
      <section>
        <p>
          この度は、XFブランドサイトへ訪問いただきありがとうございます。
          下記のお問い合わせフォームに必要事項を入力し「確認画面へ」ボタンを押してください。<br>
          <i class="c-contact-form__required"></i> の項目は必須項目となりますので必ず入力をお願い致します。
        </p>
      </section>
      <form action="" class="c-contact-form__form" @submit="onConfirm">
        <table class="c-contact-form__table">
          <tr>
            <th>お名前 <i class="c-contact-form__required"></i></th>
            <td>
              <div class="e-input-text-group">
                <label>
                  <span class="label">姓</span>
                  <input type="text" class="e-input-text -short" name="family_name" placeholder="姓" v-model="input.family_name" @blur="onBlur" :class="{'-invalid': error.family_name}">
                </label>
                <label>
                  <span class="label">名</span>
                  <input type="text" class="e-input-text -short" name="given_name" placeholder="名" v-model="input.given_name" @blur="onBlur" :class="{'-invalid': error.given_name}">
                </label>
              </div>
              <transition name="fade">
                <div class="e-error" v-if="error.family_name">{{error.family_name}}</div>
              </transition>
              <transition name="fade">
                <div class="e-error" v-if="error.given_name">{{error.given_name}}</div>
              </transition>
            </td>
          </tr>
          <tr>
            <th>電話番号 <i class="c-contact-form__required"></i></th>
            <td>
              <input type="text" class="e-input-text" name="phone" placeholder="000-000-0000" v-model="input.phone" @blur="onBlur" data-filter="zenhan" :class="{'-invalid': error.phone}">
              <transition name="fade">
                <div class="e-error" v-if="error.phone">{{error.phone}}</div>
              </transition>
            </td>
          </tr>
          <tr>
            <th>メールアドレス <i class="c-contact-form__required"></i></th>
            <td>
              <input type="text" class="e-input-text" name="email" placeholder="email@example.com" v-model="input.email" @blur="onBlur" data-filter="zenhan" :class="{'-invalid': error.email}">
              <transition name="fade">
                <div class="e-error" v-if="error.email">{{error.email}}</div>
              </transition>
              <p>ご確認の為、再度ご入力ください。</p>
              <input type="text" class="e-input-text" name="email_confirm" placeholder="email@example.com" v-model="input.email_confirm" @blur="onBlur" data-filter="zenhan" :class="{'-invalid': error.email_confirm}">
              <transition name="fade">
                <div class="e-error" v-if="error.email_confirm">{{error.email_confirm}}</div>
              </transition>
            </td>
          </tr>
          <tr>
            <th>お問い合わせ種別 <i class="c-contact-form__required"></i></th>
            <td>
              <div class="e-input-group -row">
                <label>
                  <input type="radio" class="e-input-radio" name="category" value="商品について" v-model="input.category" @change="onBlur">
                  <span class="label">商品について</span>
                </label>
                <label>
                  <input type="radio" class="e-input-radio" name="category" value="キャンペーンについて" v-model="input.category" @change="onBlur">
                  <span class="label">キャンペーンについて</span>
                </label>
                <label>
                  <input type="radio" class="e-input-radio" name="category" value="その他" v-model="input.category" @change="onBlur">
                  <span class="label">その他</span>
                </label>
              </div>
              <transition name="fade">
                <div class="e-error" v-if="error.category">{{error.category}}</div>
              </transition>
            </td>
          </tr>
          <tr>
            <th>お問い合わせ内容 <i class="c-contact-form__required"></i></th>
            <td>
              <textarea class="e-input-text" name="message" v-model="input.message" :class="{'-invalid': error.message}"></textarea>
              <transition name="fade">
                <div class="e-error" v-if="error.message">{{error.message}}</div>
              </transition>
            </td>
          </tr>
        </table>
        <div class="c-contact-form__footer">
          <button class="e-button -primary">確認画面へ</button>
        </div>
      </form>
    </div>
    <!-- /.c-contact-form__state -->

    <div class="c-contact-form__state" v-show="state === 'confirm'">
      <header>
        <h2>入力内容の確認</h2>
      </header>
      <section>
        <p>
          入力内容をご確認の上、「送信」ボタンを押してください。
          内容を修正する場合は、「修正」ボタンを押してください。
        </p>
      </section>
      <div class="c-contact-form__form">
        <table class="c-contact-form__table">
          <tr>
            <th>お名前</th>
            <td>{{input.family_name}} {{input.given_name}}</td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td>{{input.phone}}</td>
          </tr>
          <tr>
            <th>メールアドレス</th>
            <td>{{input.email}}</td>
          </tr>
          <tr>
            <th>お問い合わせ種別</th>
            <td>{{input.category}}</td>
          </tr>
          <tr>
            <th>お問い合わせ内容</th>
            <td v-nl2br="input.message"></td>
          </tr>
        </table>
        <div class="c-contact-form__footer">
          <button class="e-button" @click="onEdit">修正</button>
          <button class="e-button -primary" @click="onSubmit">送信</button>
        </div>
      </div>
    </div>
    <!-- /.c-contact-form__state -->
    <div class="c-contact-form__state" v-show="state === 'error'">
      <header>
        <h2>エラーが発生しました</h2>
      </header>
      <section>
        <p>
          メッセージの送信中にエラーが発生しました。<br>
          お手数ですが、しばらくしてから再度お試しいただくか、<a :href="'mailto:' + ownerMail">{{ownerMail}}</a> までお問い合わせください。
        </p>
      </section>
    </div>
    <!-- /.c-contact-form__state -->
    <div class="c-contact-form__state" v-show="state === 'complete'">
      <header>
        <h2>お問い合わせいただき、ありがとうございました。</h2>
      </header>
      <section>
        <p class="e-center">
          ただいま、お問い合わせ内容の確認メールをご登録のメールアドレスにお送り致しました。<br>
          万が一確認のメールがこない場合は、お手数ですが、下記よりお問い合わせください。
        </p>
        <p class="e-center">
          E-mail: <a :href="'mailto:' + ownerMail">{{ownerMail}}</a>
        </p>
        <p class="e-center">
          ※万が一お手元に届かない場合は、迷惑メールフォルダに入っている可能性がございます。念のため、迷惑メールフォルダもご確認くださいませ。<br>
          ※ドメイン受信設定をされている方は、{{ownerMail}}からメールが届くように設定をお願いいたします。
        </p>
        <p class="e-center">
          <a href="/">XFブランドサイトトップページへ</a>
        </p>
      </section>
    </div>
    <!-- /.c-contact-form__state -->
  </div>
</template>

<script>

import fields from "../data/contact-form-fields.js";
import filters from "../lib/filters.js";
import u from "../lib/u.js";

export default {

  data (){
    return {
      endpoint: "/api/index.php",
      fields,
      state: "form",
      token: null,
      input: {
        family_name: null,
        given_name: null,
        phone: null,
        email: null,
        email_confirm: null,
        category: null,
        message: null
      },
      error: {
        family_name: null,
        given_name: null,
        phone: null,
        email: null,
        email_confirm: null,
        category: null,
        message: null
      },
      ownerMail: "info@thexf.net"
    }
  },

  mounted (){
    if(location.hostname === "localhost") {
      this.endpoint = "http://localhost:9090" + this.endpoint;
    }

    this.request({
      url: "/token"
    })
    .then((r) => {
      this.token = r.token;
    });

    // test values
    if(location.search === "?test"){
      const testdata = {
        family_name: "田中",
        given_name: "太郎",
        phone: "0123-4560-789",
        email: "test@example.com",
        email_confirm: "test@example.com",
        category: "その他",
        message: "あの<a href=></a>イーハトーヴォのすきとおった風\n夏でも底に冷たさをもつ青いそら\nうつくしい森で飾られたモリーオ市\n郊外のぎらぎらひかる草の波"
      };
      Object.keys(testdata).map((key) => {
        this.input[key] = testdata[key];
      });
    }
  },

  watch: {
    state (){
      $("html,body").animate({scrollTop: 0}, 300);
    }
  },

  directives: {
    nl2br (el, o){
      if(! o.value) return null;
      let body = u.escape(o.value);
      body = body.split("\n").join("<br>");
      el.innerHTML = body;
    }
  },

  methods: {

    request (props){
      if(location.hostname === "localhost"){
        props.xhrFields = {
          withCredentials: true
        };
      }
      props.url = this.endpoint + props.url;
      return $.ajax(props);
    },

    onBlur (e){
      const el = e.target;
      const filter = el.getAttribute("data-filter");
      const value = this.input[el.name];

      if(filter && filters[filter] && !! value){
        this.input[el.name] = filters[filter](value);
      }
      this.validate(el.name);
    },

    validate (name){
      if(! this.fields[name]){ return; }
      const field = this.fields[name];
      const value = this.input[name];
      let valid = true;

      if(field.required && !value) {
        return this.setError(name, field.message);
      }

      Array.isArray(field.rules) && field.rules.map((r) => {
        switch(r.name){
          case "length":
            if(Array.from(value).length > r.value){
              this.setError(name, r.message);
              valid = false;
            }
            break;
          case "pattern":
            if(! r.value.test(value)){
              this.setError(name, r.message);
              valid = false;
            }
            break;
          case "email":
            if(! u.isEmail(value)){
              this.setError(name, r.message);
              valid = false;
            }
            break;
          case "equal":
            if(this.input[r.value] !== value){
              this.setError(name, r.message);
              valid = false;
            }
            break;
          default: break;
        }
      });

      if(valid) {
        this.setError(name, null);
      }
    },

    onConfirm (e){
      // validate all
      e.preventDefault();

      let valid = true;

      Object.keys(this.error)
      .map(this.validate);

      Object.values(this.error)
      .map((message) => {
        if(!! message){
          valid = false;
        }
      });

      if(valid){
        this.state = "confirm";
      }
    },

    onSubmit (e){
      e.target.disabled = true;

      let data = {};
      Object.keys(this.input).map((name) => {
        data[name] = this.input[name];
      });
      data.token = this.token;

      this.request({
        url: "/contact",
        data,
        type: "post"
      })
      .then(
        () => {
          this.state = "complete";
        },
        () => {
          this.state = "error";
        }
      );
    },

    onEdit (e){
      this.state = "form";
    },

    setError (name, message){
      this.error[name] = message;
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/component/contact-form.vue